import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Select } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IIapProductType } from './IapProductsData';
import { getFormattedIapProductPrice } from './getFormattedIapProductPrice';
import { iapProducts } from './IapProductsData';

export type IIapProductSelectorProps = IOmit<ISelectProps, 'items'> & {
  productType?: IIapProductType;
  availableProductIds?: Array<string>;
  paidOnly?: boolean;
  noSupportingText?: boolean;
  includeFreeOption?: boolean;
};

export const IapProductSelector = forwardRef<
  HTMLDivElement,
  IIapProductSelectorProps
>(function IapProductSelector(props, forwardedRef) {
  const {
    productType,
    availableProductIds,
    paidOnly,
    noSupportingText,
    ...other
  } = props;
  const { t } = useTranslation();
  const products = productType
    ? iapProducts
        .filter((product) => product.type === productType)
        .filter((product) =>
          availableProductIds
            ? availableProductIds?.includes(product._id)
            : true,
        )
    : iapProducts;
  const items: Array<IFilterableListItem> = [
    ...(paidOnly
      ? []
      : [
          {
            value: '',
            label: t('IapProductSelector.free'),
          },
        ]),
    ...products.map((product) => ({
      value: product._id,
      label: getFormattedIapProductPrice(product.customerPrice),
      supportingText: t('IapProductSelector.yourProceeds', {
        proceeds: getFormattedIapProductPrice(product.proceeds),
      }),
    })),
  ];

  return (
    <Select
      supportingText={
        noSupportingText ? undefined : t('IapProductSelector.supportingText')
      }
      {...other}
      items={items}
      ref={forwardedRef}
    />
  );
});
